import React from "react";
import PropTypes from "prop-types";
/* eslint-disable import/no-unresolved */
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
/* eslint-enable import/no-unresolved */
import { useCookies } from "react-cookie";
// import GlobalHeader from "../Components/GlobalHeader";
// import GlobalFooter from "../Components/GlobalFooter/GlobalFooter";

import PageHeader from "../Components/PageHeader";
import NavMenu from "../Components/NavMenu";
import Homepage from "../Components/Homepage";
import DrupalPage from "../Components/DrupalPage";
import Footer from "../Components/Footer";

import { MediaContextProvider } from "../lib/MediaContext";
import { UiStatesContextProvider } from "../lib/UiStates";

import css from "./App.module.scss";

/* eslint-disable react/forbid-prop-types */

const COOKIE_ID = "GalleryGuides.LimitGuide";
const COOKIE_PREFS = { path: "/" };

const FrontendApp = ({ initQuery = {} }) => {
  const [
    limitGuideCookie,
    setLimitGuideCookie,
    removeLimitGuideCookie
  ] = useCookies([COOKIE_ID]);

  React.useEffect(() => {
    if (typeof initQuery.limitGuide !== "undefined") {
      if ((initQuery.limitGuide || "").length) {
        setLimitGuideCookie(COOKIE_ID, initQuery.limitGuide, COOKIE_PREFS);
      } else {
        removeLimitGuideCookie(COOKIE_ID, COOKIE_PREFS);
      }
    }
  }, []);

  const limitGuide =
    limitGuideCookie[COOKIE_ID] || initQuery.limitGuide || null;

  return (
    <Router basename="/">
      <UiStatesContextProvider>
        <MediaContextProvider>
          <div className={css.app}>
            {/* <PageHeader /> */}
            {/* <NavMenu
              className={css.header}
              menuPadding={
                document
                  .querySelector("body")
                  .className.indexOf("toolbar-fixed") >= 0
              }
              limitGuide={limitGuide}
            /> */}
            <Switch>
              <Route
                exact
                path="/"
                render={() => {
                  if (limitGuide) {
                    return (
                      <DrupalPage
                        className={css.body}
                        location={{ pathname: `/node/${limitGuide}` }}
                        limitGuide={limitGuide}
                      />
                    );
                  }
                  return <Homepage className={css.body} />;
                }}
              />
              <Route
                render={({ location }) => (
                  <DrupalPage
                    className={css.body}
                    location={location}
                    limitGuide={limitGuide}
                  />
                )}
              />
            </Switch>
            {/* {limitGuide === null && (
              <Footer className={css.footer} />
              // venueId={22861}
            )} */}

          </div>
        </MediaContextProvider>
      </UiStatesContextProvider>
    </Router>
  );
};

FrontendApp.propTypes = {
  initQuery: PropTypes.object
};

FrontendApp.defaultProps = {
  initQuery: {}
};

export default FrontendApp;
